import api from '../api/apiConfig'

export default {
  namespaced: true,
  state: {
    currentList: []
  },
  getters: {},
  mutations: {
    setCurrentList (state, inspectionList) {
      state.currentList = inspectionList
    }
  },
  actions: {
    async addFile ({rootState}, data) {
      const content = data.file
      delete data.file
      const meta = {
        isFolder: false,
        ...data,
        project: rootState.project.current._id
      }

      const { location } = await api.addFileMeta(meta)

      await api.addFileContent(location, content)
    },
    async addFolder ({rootState}, {parent, folderName}) {
      const meta = {
        parent: parent,
        isFolder: true,
        name: folderName,
        project: rootState.project.current._id
      }
      await api.addFileMeta(meta)
    },
    async storeList ({rootState, commit}) {
      commit('setCurrentList', await api.getProjectFiles(rootState.project.current._id))
    },
    async deleteOne ({state}, _id) {
      await api.deleteFile(_id)
    },
    async patchFile ({rootState}, meta) {
      await api.patchFile(meta)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/file.js